import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { toggleEventPreviewMode } from "../../../../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import ModalComponent from "../../../../../general-ui/modal/modal";
import LiveEventDocumentHead from "../../../../../live-event/live-event-document-head";
import MarketingPage from "../../../../../live-event/marketing-page/marketing-page";
import '../../../../../general-ui/session-preview/event-preview.scss';
import className from 'classnames';
import { useParams } from "react-router";
import { ParamsProps } from "../../../../../live-event/live-event";
import { EPreviewTypes } from "../../../../../../types/working-model";

interface LandingPreviewProps {
	open: boolean;
}

const LandingPreviewModal: React.FC<LandingPreviewProps> = ({ open }) => {

	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const editorSize = useTypedSelector(state => state.CreateEventReducer.editorSize);
	const previewMode = useTypedSelector(state => state.CreateEventReducer.previewMode);

	const dispatch = useDispatch();

	const { language } = useParams() as ParamsProps;

	const template = workingEvent?.template?.name?.toLocaleLowerCase().replace(/\s/g, '') ?? '';

	const modalBody = useMemo(() => {
		return workingEvent && (
			<div className={className("event-preview-wrapper live-event-container", editorSize, template)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<MarketingPage previewEventBundle={workingEvent} previewLanguage={language || "en"} />
			</div>
		);
	}, [workingEvent, editorSize, language, template]);

	const closeModal = useCallback(() => {
		dispatch(toggleEventPreviewMode(null));
	}, [dispatch]);

	return (
		<div
			className="preview-modal"
			style={previewMode !== EPreviewTypes.Landing ? { display: 'none' } : {}}
		>
			<ModalComponent
				open={open}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default LandingPreviewModal;